export default "__VITE_ASSET__48bb8175__"